import { ChecklistAccordionGroup } from '@app/interfaces';

export function convertToChecklistAccordionGroup(attributes: ChecklistAccordionGroup[]): ChecklistAccordionGroup[] {
    const data = [...attributes];

    return data.map((item) => {
        item.showSelectAll = true;
        item.options.forEach((option) => (option.checked = false));
        return item;
    });
}
